import React, { useEffect, useState } from "react";
import MainBanner from "../../Components/Banner/MainBanner";
import Footer from "../../Components/Footer/Footer";
import Header from "../../Components/Header/Header";
import "../../assets/css/CSAMembership.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { arrow, checkbox2 } from "../../constant";
import StripeForm from "../../Components/PaymentMethod/StripeForm";
import ActionButton from "../../Components/ActionBtn/ActionButton";
import {
  bookMemberShipPost,
  PostCSAProductPriceById,
  PostMembershipById,
} from "../../network/Network";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { toast } from "react-toastify";
import Skeleton from "react-loading-skeleton";

function CSAMEMBERship() {
  const navigate = useNavigate();
  const ImageUrlRedux = useSelector((state) => state.AuthReducer.urlData);

  const Token = useSelector((state) => state?.AuthReducer?.token);
  const [loading, setLoading] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [csaMembership, setCsaMembership] = useState();
  const [csaPriceList, setCsaPriceList] = useState();
  const [repeatType, setRepeatType] = useState();
  const [variation, setVariation] = useState();
  const [priceVal, setPriceVal] = useState();
  const styling = {
    marginTop: "10px",
    width: "100%",
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  let selectBox = [
    { id: 1, text: "Weekly", price: "$25.00" },
    { id: 2, text: "Bi-Weekly", price: "$25.00" },
    { id: 3, text: "Monthly", price: "$25.00" },
  ];

  // Get Membership by id
  useEffect(() => {
    setLoading(true);
    PostMembershipById(5)
      .then((res) => {
        setLoading(false);
        setCsaMembership(res?.data);
        setVariation(res?.data?.csa_product[0]);
        setRepeatType(res?.data?.csa_product[0]?.csa_product_price[0]?.id);
        setPriceVal(res?.data?.csa_product[0]?.csa_product_price[0]?.price);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  const CsaPackagePrice = (e, id, item) => {
    e.preventDefault();
    setLoading(true);
    PostCSAProductPriceById(id)
      .then((res) => {
        setLoading(false);
        setCsaPriceList(res?.data);
        setVariation(item);
        setRepeatType(item?.csa_product_price?.[0]?.id);
        setPriceVal(item?.csa_product_price?.[0]?.price);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const PlaceOrderHandler = (e, stripe_token) => {
    setLoadingBtn(true);
    e.preventDefault();
    if (!repeatType || !variation?.id || !priceVal) {
      toast.error("Please fill all fields");
      setLoadingBtn(false);
    } else {
      let sendData = {
        membership_id: 5,
        _token: stripe_token,
        csa_type: repeatType,
        csa_product_id: variation?.id,
        csa_price_id: variation.csa_product_price.filter((item) => {
          return item.id == repeatType;
        })?.[0]?.id,
        price: variation.csa_product_price.filter((item) => {
          return item.id == repeatType;
        })?.[0]?.price,
        type: "membership",
        csa_type: variation?.id,
        platform: "hoho",
      };
      bookMemberShipPost(sendData, Token)
        .then((res) => {
          setLoadingBtn(false);
          navigate("/");
          toast.success("CSA membership booking has been done successfully");
        })
        .catch((err) => {
          toast.error(`${err?.response?.data?.message}`);
          setLoadingBtn(false);
          // console.log(err);
        });
    }
  };

  const setRepeatTypeFunc = (value, price) => {
    setRepeatType(value);
    setPriceVal(price);
  };

  return (
    <>
      <Header />
      <MainBanner name={"CSA Membership"} />
      <section className="Membership-page">
        <div className="container">
          {loading ? (
            <Skeleton count={5} />
          ) : (
            <div>
              <h2 className="main-Title">{csaMembership?.heading}</h2>
              <p className="main-para">{csaMembership?.description}</p>
              <ActionButton />
              <div className="membership-card">
                <div className="row">
                  {csaMembership?.csa_product?.map((item, index) => {
                    return (
                      <div className="col-lg-4 mt-4" key={index}>
                        <div className="card cardStyle2">
                          <img
                            className="img_csa_membership_image"
                            src={`${ImageUrlRedux?.csa_image_url}/${item?.image}`}
                            alt=""
                          />
                          <h4>{item?.title}</h4>
                          <h6>{item?.subtitle}</h6>
                          <p className="main-para12">{item?.description}</p>
                          <button
                            className={
                              variation.id === item.id
                                ? `btn bg_clr_blkk`
                                : `btn`
                            }
                            onClick={(e) => CsaPackagePrice(e, item?.id, item)}
                          >
                            BUY MEMBERSHIP TO GET
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="formContainer">
                <h2 className="main-Title">Get CSA Membership</h2>
                <p className="main-para">{variation?.description}</p>
                <div className="row">
                  <div className="col-lg-4"></div>
                  <div className="col-lg-4">
                    <div className="set-paymentDetail">
                      <h6 className="margin-settin text-center">
                        Select Subscription Type
                      </h6>
                      {variation?.csa_product_price.map((item, index) => {
                        return (
                          <div
                            key={index + 81964}
                            className={
                              repeatType == item?.id
                                ? "check_box_green_booking mr-2"
                                : "check_box_green_booking_normal mr-2"
                            }
                          >
                            <input
                              onClick={(e) => {
                                setRepeatTypeFunc(e.target.value, item?.price);
                              }}
                              checked={repeatType == `${item?.id}`}
                              value={`${item?.id}`}
                              type="checkbox"
                            />
                            <span>{item?.type}</span>
                            <span>$ {item?.price}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="offset-lg-3 col-lg-6">
                    {Token ? (
                      <>
                        <p className="sub-title">Payment Details </p>
                        <StripeForm
                          styling={styling}
                          paynow="SUBMIT"
                          PaymentHandler={PlaceOrderHandler}
                          loading={loadingBtn}
                        />
                      </>
                    ) : (
                      <>
                        <p className="sub-title">Payment Details </p>
                        <div className="camping_btn">
                          <button
                            onClick={() => {
                              navigate("/login");
                            }}
                            className="btn"
                          >
                            Sign In
                            <img src={arrow} className="image-fluid pl-2" />
                          </button>
                          <button
                            onClick={() => {
                              navigate("/signup");
                            }}
                            className="btn secondbtn"
                          >
                            Create An Account
                            <img src={arrow} className="image-fluid pl-2" />
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
      <Footer />
    </>
  );
}

export default CSAMEMBERship;
